import { render, staticRenderFns } from "./Purchaser.vue?vue&type=template&id=77f64e30&scoped=true&"
import script from "./Purchaser.vue?vue&type=script&lang=ts&"
export * from "./Purchaser.vue?vue&type=script&lang=ts&"
import style0 from "./Purchaser.vue?vue&type=style&index=0&id=77f64e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f64e30",
  null
  
)

export default component.exports